import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { __Currency, __UrlParams } from "../../../_core/core";

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
// import { Carousel } from 'react-responsive-carousel';
import ReactSimplyCarousel from "react-simply-carousel";

import moment from "moment";
//import STYLES
import "./Winners.styles.css";
import useMediaQuery from "../../../_core/hooks/useMediaQuery";

const getCurrentEndpoint = () => {
  // console.log(decodeURIComponent(__UrlParams.props.siteID));
  switch (__UrlParams.props.endpoint) {
    case "dev.cbcontents.com":
      return `https://uat.cbcontents.com/marlipin/launch/feed.jsp?siteID=${decodeURIComponent(
        __UrlParams.props.siteID
      )}&brandID=${__UrlParams.props.brandID}&gameID=${
        __UrlParams.props.gameID
      }`;
    case "uat.cbcontents.com":
      return `https://uat.cbcontents.com/marlipin/launch/feed.jsp?siteID=${decodeURIComponent(
        __UrlParams.props.siteID
      )}&brandID=${__UrlParams.props.brandID}&gameID=${
        __UrlParams.props.gameID
      }`;
    case "prod1.cbcontents.com":
      return `https://prod1.cbcontents.com/marlipin/launch/feed.jsp?siteID=${decodeURIComponent(
        __UrlParams.props.siteID
      )}&brandID=${__UrlParams.props.brandID}&gameID=${
        __UrlParams.props.gameID
      }`;
    default:
      return `https://uat.cbcontents.com/marlipin/launch/feed.jsp?siteID="${decodeURIComponent(
        __UrlParams.props.siteID
      )}&brandID=${__UrlParams.props.brandID}&gameID=${
        __UrlParams.props.gameID
      }`;
  }
};

const Winners = (_props: any) => {
  const [winners, setWinners] = useState<any[]>([]);
  const isMobile = useMediaQuery("(max-width: 500px)");
  const [activeSlide, setActiveSlide] = useState(0);

  const formateDate = (date: any) => moment(date).fromNow(true);
  const calculateCarouselItemWidth = (isMobile: boolean) => {
    //@ts-ignore
    let visibleArea = document.querySelector(".gameplay-container");
    if (visibleArea) {
      return isMobile ? 250 : visibleArea.clientWidth / 3 - 5;
    }

    return 800 / 3;
  };

  const fetchWinners = async () => {
    const currentEndpoint = getCurrentEndpoint();
    if (
      parseInt(__UrlParams.props.siteID) !== 30 &&
      parseInt(__UrlParams.props.brandID) !== 2
    )
      return null;
    try {
      let { prizeWinners } = await fetch(currentEndpoint).then(async (res) => {
        return res.json();
      });

      setWinners([...prizeWinners, ...prizeWinners, ...prizeWinners]);
    } catch (err) {
      console.log("WINNER_TOOL err:", err);
    }
  };

  useEffect(() => {
    fetchWinners();
  }, [_props.drawStart]);

  if (!winners.length) return null;

  if (parseInt(__UrlParams.props.siteID) === 30) return null;

  return (
    <div className={`gameplay-container winners-wrapper`}>
      <div className="winners-container">
        <ReactSimplyCarousel
          containerProps={{
            style: {
              width: "100%",
              justifyContent: "center",
              userSelect: "none",
            },
          }}
          itemsToShow={3}
          itemsToScroll={1}
          responsiveProps={[
            {
              itemsToShow: 3,
              itemsToScroll: 1,
              minWidth: 768,
            },
            {
              itemsToShow: 3,
              itemsToScroll: 1,
              maxWidth: 500,
            },
          ]}
          activeSlideIndex={activeSlide}
          autoplay={true}
          onRequestChange={setActiveSlide}
          forwardBtnProps={{
            show: false,
          }}
          backwardBtnProps={{
            show: false,
          }}
          centerMode={true}
          disableSwipeByMouse={false}
          delay={2000}
          speed={400}
          easing="linear"
        >
          {winners &&
            winners.map((winner, index) => (
              <div
                className="winner-item"
                key={`Winner_${index}`}
                style={{ width: calculateCarouselItemWidth(isMobile) + "px" }}
              >
                <div className="winner-item-inner">
                  {winner.displayName} just{" "}
                  <b>
                    won {__Currency.formatFromCurrency(winner.winAmount, "AUD")}
                  </b>
                  {winner.bigWinner === "true" ? (
                    <span className="winners-big-won">won big</span>
                  ) : (
                    <span className="winners-time">
                      {formateDate(winner.dateTimeWon)} ago
                    </span>
                  )}
                </div>
              </div>
            ))}
        </ReactSimplyCarousel>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    drawStart: state.game.GAMEPLAY.drawStart,
  };
};

export default connect(mapStateToProps, {})(Winners);
